<div class="page-container">
    <div class="header-section">
        <h1>User Management</h1>
        <button class="btn-primary" (click)="openCreateDialog()">
            <span class="material-icons">add</span>
            New User
        </button>
    </div>

    <div class="filter-section">
        <div class="search-box">
            <span class="material-icons search-icon">search</span>
            <input pInputText [(ngModel)]="searchText" (input)="onSearchChange()"
                placeholder="Search by name, email or role..." class="search-input" />
            <button *ngIf="searchText" class="clear-search-btn" (click)="clearSearch()">
                <span class="material-icons">close</span>
            </button>
        </div>
        <div class="filter-info">
            <span class="result-count">{{ gridView.total }} Users found</span>
        </div>
    </div>

    <div *ngIf="loading" class="loading-container">
        <p-progressSpinner styleClass="labtech-spinner" ariaLabel="Loading"></p-progressSpinner>
        <p>Loading users...</p>
    </div>

    <div class="cards-grid" *ngIf="!loading">
        <div class="card" *ngFor="let user of gridView.data" [@cardAnimation]>
            <div class="card-header">
                <div class="card-icon">
                    <span class="material-icons">person</span>
                </div>
                <div class="card-title-section">
                    <h3 class="card-title">{{ user.username || 'N/A' }}</h3>
                    <span class="card-subtitle">{{ user.email || 'N/A' }}</span>
                </div>
                <div class="overview-card-actions">
                    <button type="button" class="card-icon-btn" (click)="toggleActionMenu(user.id, $event)"
                        [attr.aria-expanded]="isActionMenuOpen(user.id)" title="User actions">
                        <span class="material-icons">more_vert</span>
                    </button>
                    <div class="card-action-menu" *ngIf="isActionMenuOpen(user.id)" (click)="$event.stopPropagation()">
                        <button type="button" class="menu-action" (click)="closeActionMenu(); openEditDialog(user)">
                            <span class="material-icons">edit</span>
                            Edit
                        </button>
                        <button type="button" class="menu-action" (click)="closeActionMenu(); toggleUserStatus(user)">
                            <span class="material-icons">{{ user.isActive ? 'person_off' : 'person' }}</span>
                            {{ user.isActive ? 'Deactivate' : 'Activate' }}
                        </button>
                        <button type="button" class="menu-action menu-action-danger"
                            (click)="closeActionMenu(); deleteUser(user)">
                            <span class="material-icons">delete</span>
                            Delete
                        </button>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <div class="info-row">
                    <span class="material-icons info-icon">admin_panel_settings</span>
                    <span class="info-label">Role</span>
                    <span class="status-badge badge-info">{{ getRoleDisplayName(user.role) || 'N/A' }}</span>
                </div>
                <div class="info-row">
                    <span class="material-icons info-icon">login</span>
                    <span class="info-label">Login</span>
                    <span class="status-badge badge-info">{{ getLoginMethodDisplayName(user) }}</span>
                </div>
                <div class="info-row">
                    <span class="material-icons info-icon">security</span>
                    <span class="info-label">MFA</span>
                    <span class="status-badge" [class.active]="user.mfaEnabled">
                        {{ user.mfaEnabled ? 'Enabled' : 'Pending' }}
                    </span>
                </div>
                <div class="info-row">
                    <span class="material-icons info-icon">toggle_on</span>
                    <span class="info-label">Status</span>
                    <span class="status-badge" [class.active]="user.isActive">
                        {{ user.isActive ? 'Active' : 'Inactive' }}
                    </span>
                </div>
                <div class="info-row">
                    <span class="material-icons info-icon">event</span>
                    <span class="info-label">Created</span>
                    <span class="status-badge badge-info">{{ user.createdAt | date:'dd.MM.yyyy' }}</span>
                </div>
            </div>

        </div>
    </div>

    <app-empty-state
        *ngIf="!loading && gridView.data.length === 0"
        icon="search_off"
        headline="No users found"
        [subline]="searchText ? 'Try adjusting your search criteria' : 'Click &quot;New User&quot; to create your first user'">
    </app-empty-state>

    <div class="pagination-section" *ngIf="!loading && gridView.total > 0">
        <p-paginator [totalRecords]="gridView.total" [rows]="state.take ?? 12" [first]="state.skip ?? 0"
            [rowsPerPageOptions]="[12, 24, 48]" (onPageChange)="pageChange($event)"></p-paginator>
        <span class="result-count pagination-range">{{ footerRangeLabel }}</span>
    </div>
</div>

<ng-container *ngIf="deleteDialog">
    <p-dialog [modal]="true" [visible]="true" header="Delete User" (onHide)="toggleDeleteDialog()" [style]="{ width: '450px' }">
        <div class="dialog-content">
            <p>Are you sure you want to delete user <strong>{{ selectedUser?.username }}</strong>?</p>
            <p class="dialog-warning-text">This action cannot be undone.</p>
        </div>
        <ng-template pTemplate="footer">
            <button class="btn-secondary" (click)="toggleDeleteDialog()">Cancel</button>
            <button class="btn-primary" (click)="confirmDelete()">
                <span class="material-icons">delete</span>
                Delete
            </button>
        </ng-template>
    </p-dialog>
</ng-container>
